import React from "react";

const CloseError = props => (
  <svg viewBox="0 0 51 50" fill="none" {...props}>
    <path
      d="M34.781 25l14.063-14.063a4.176 4.176 0 000-6.187L45.75 1.656a4.176 4.176 0 00-6.188 0L25.5 15.72 11.297 1.656a4.176 4.176 0 00-6.188 0L2.016 4.75a4.176 4.176 0 000 6.188L16.078 25 2.016 39.203a4.176 4.176 0 000 6.188l3.093 3.093a4.176 4.176 0 006.188 0L25.5 34.422l14.063 14.062a4.176 4.176 0 006.187 0l3.094-3.093a4.176 4.176 0 000-6.188L34.78 25z"
      fill="#FFC1C1"
    />
  </svg>
);

export default CloseError;
